import { getName } from "country-list"

const countries = [
  { name: "Afghanistan", code: "AFG", id: "004" },
  { name: "Albania", code: "ALB", id: "008" },
  { name: "Algeria", code: "DZA", id: "012" },
  { name: "Angola", code: "AGO", id: "024" },
  { name: "Antigua and Barbuda", code: "ATG", id: "028" },
  { name: "Argentina", code: "ARG", id: "032" },
  { name: "Australia", code: "AUS", id: "036" },
  { name: "Austria", code: "AUT", id: "040" },
  { name: "The Bahamas", code: "BHS", id: "044" },
  { name: "Bangladesh", code: "BGD", id: "050" },
  { name: "Barbados", code: "BRB", id: "052" },
  { name: "Belarus", code: "BLR", id: "112" },
  { name: "Belgium", code: "BEL", id: "056" },
  { name: "Belize", code: "BLZ", id: "084" },
  { name: "Benin", code: "BEN", id: "204" },
  { name: "Bolivia", code: "BOL", id: "068" },
  { name: "Bosnia and Herzegovina", code: "BIH", id: "070" },
  { name: "Botswana", code: "BWA", id: "072" },
  { name: "Brazil", code: "BRA", id: "076" },
  { name: "Bulgaria", code: "BGR", id: "100" },
  { name: "Burkina Faso", code: "BFA", id: "854" },
  { name: "Cambodia", code: "KHM", id: "116" },
  { name: "Cameroon", code: "CMR", id: "120" },
  { name: "Canada", code: "CAN", id: "124" },
  { name: "Chile", code: "CHL", id: "152" },
  { name: "China", code: "CHN", id: "156" },
  { name: "Colombia", code: "COL", id: "170" },
  { name: "Congo, Dem. Rep.", code: "COD", id: "180" },
  { name: "Costa Rica", code: "CRI", id: "188" },
  { name: "Côte d'Ivoire", code: "CIV", id: "384" },
  { name: "Croatia", code: "HRV", id: "191" },
  { name: "Czechia", code: "CZE", id: "203" },
  { name: "Denmark", code: "DNK", id: "208" },
  { name: "Dominica", code: "DMA", id: "212" },
  { name: "Dominican Republic", code: "DOM", id: "214" },
  { name: "Ecuador", code: "ECU", id: "218" },
  { name: "Egypt, Arab Rep.", code: "EGY", id: "818" },
  { name: "El Salvador", code: "SLV", id: "222" },
  { name: "Estonia", code: "EST", id: "233" },
  { name: "Ethiopia", code: "ETH", id: "231" },
  { name: "Finland", code: "FIN", id: "246" },
  { name: "France", code: "FRA", id: "250" },
  { name: "Georgia", code: "GEO", id: "268" },
  { name: "Germany", code: "DEU", id: "276" },
  { name: "Ghana", code: "GHA", id: "288" },
  { name: "Greece", code: "GRC", id: "300" },
  { name: "Grenada", code: "GRD", id: "308" },
  { name: "Guatemala", code: "GTM", id: "320" },
  { name: "Guinea", code: "GIN", id: "324" },
  { name: "Guyana", code: "GUY", id: "328" },
  { name: "Honduras", code: "HND", id: "340" },
  { name: "Hong Kong SAR, China", code: "HKG", id: "344" },
  { name: "Hungary", code: "HUN", id: "348" },
  { name: "India", code: "IND", id: "356" },
  { name: "Indonesia", code: "IDN", id: "360" },
  { name: "Iran, Islamic Rep.", code: "IRN", id: "364" },
  { name: "Italy", code: "ITA", id: "380" },
  { name: "Jamaica", code: "JAM", id: "388" },
  { name: "Japan", code: "JPN", id: "392" },
  { name: "Jordan", code: "JOR", id: "400" },
  { name: "Kazakhstan", code: "KAZ", id: "398" },
  { name: "Kenya", code: "KEN", id: "404" },
  { name: "Kyrgyz Republic", code: "KGZ", id: "417" },
  { name: "Lebanon", code: "LBN", id: "422" },
  { name: "Liberia", code: "LBR", id: "430" },
  { name: "North Macedonia", code: "MKD", id: "807" },
  { name: "Madagascar", code: "MDG", id: "450" },
  { name: "Malawi", code: "MWI", id: "454" },
  { name: "Malaysia", code: "MYS", id: "458" },
  { name: "Mali", code: "MLI", id: "466" },
  { name: "Mauritania", code: "MRT", id: "478" },
  { name: "Mauritius", code: "MUS", id: "480" },
  { name: "Mexico", code: "MEX", id: "484" },
  { name: "Moldova", code: "MDA", id: "498" },
  { name: "Mongolia", code: "MNG", id: "496" },
  { name: "Morocco", code: "MAR", id: "504" },
  { name: "Mozambique", code: "MOZ", id: "508" },
  { name: "Myanmar", code: "MMR", id: "104" },
  { name: "Namibia", code: "NAM", id: "516" },
  { name: "Nepal", code: "NPL", id: "524" },
  { name: "Netherlands", code: "NLD", id: "528" },
  { name: "New Zealand", code: "NZL", id: "554" },
  { name: "Nicaragua", code: "NIC", id: "558" },
  { name: "Niger", code: "NER", id: "562" },
  { name: "Nigeria", code: "NGA", id: "566" },
  { name: "Norway", code: "NOR", id: "578" },
  { name: "Pakistan", code: "PAK", id: "586" },
  { name: "Panama", code: "PAN", id: "591" },
  { name: "Peru", code: "PER", id: "604" },
  { name: "Philippines", code: "PHL", id: "608" },
  { name: "Poland", code: "POL", id: "616" },
  { name: "Portugal", code: "PRT", id: "620" },
  { name: "Korea, Rep.", code: "KOR", id: "410" },
  { name: "Romania", code: "ROU", id: "642" },
  { name: "Russian Federation", code: "RUS", id: "643" },
  { name: "Rwanda", code: "RWA", id: "646" },
  { name: "Senegal", code: "SEN", id: "686" },
  { name: "Serbia", code: "SRB", id: "688" },
  { name: "Sierra Leone", code: "SLE", id: "694" },
  { name: "Singapore", code: "SGP", id: "702" },
  { name: "Slovenia", code: "SVN", id: "705" },
  { name: "South Africa", code: "ZAF", id: "710" },
  { name: "Spain", code: "ESP", id: "724" },
  { name: "Sri Lanka", code: "LKA", id: "144" },
  { name: "St. Kitts and Nevis", code: "KNA", id: "659" },
  { name: "St. Lucia", code: "LCA", id: "662" },
  { name: "St. Vincent and the Grenadines", code: "VCT", id: "670" },
  { name: "Suriname", code: "SUR", id: "740" },
  { name: "Sweden", code: "SWE", id: "752" },
  { name: "Tanzania", code: "TZA", id: "834" },
  { name: "Thailand", code: "THA", id: "764" },
  { name: "Togo", code: "TGO", id: "768" },
  { name: "Trinidad and Tobago", code: "TTO", id: "780" },
  { name: "Tunisia", code: "TUN", id: "788" },
  { name: "Türkiye", code: "TUR", id: "792" },
  { name: "Uganda", code: "UGA", id: "800" },
  { name: "Ukraine", code: "UKR", id: "804" },
  { name: "United Arab Emirates", code: "ARE", id: "784" },
  { name: "United Kingdom", code: "GBR", id: "826" },
  { name: "United States", code: "USA", id: "840" },
  { name: "Uruguay", code: "URY", id: "858" },
  { name: "Uzbekistan", code: "UZB", id: "860" },
  { name: "Venezuela, RB", code: "VEN", id: "862" },
  { name: "Vietnam", code: "VNM", id: "704" },
  { name: "Zambia", code: "ZMB", id: "894" },
  { name: "Zimbabwe", code: "ZWE", id: "716" },

  { name: "The Gambia", code: "GMB", id: "270" },
  { name: "Kosovo", code: "XKX", id: "383" },

  { name: "Haiti", code: "HTI", id: "332" },
  { name: "Sudan", code: "SDN", id: "729" },
  { name: "Cyprus", code: "CYP", id: "196" },
  { name: "Ireland", code: "IRL", id: "372" },
  { name: "Latvia", code: "LVA", id: "428" },
  { name: "Lithuania", code: "LTU", id: "440" },
  { name: "Luxembourg", code: "LUX", id: "442" },
  { name: "Malta", code: "MLT", id: "470" },
  { name: "Paraguay", code: "PRY", id: "600" },
  { name: "Slovak Republic", code: "SVK", id: "703" },
  { name: "Congo, Rep.", code: "COG", id: "178" },
  { name: "Gabon", code: "GAB", id: "266" },
  { name: "Kuwait", code: "KWT", id: "414" },
  { name: "Montenegro", code: "MNE", id: "499" },
  { name: "Qatar", code: "QAT", id: "634" },
]

export function getCountryByName(name) {
  return countries.find((n) => n.name === name)
}

let id = 999
export function getCountryByCode(code) {
  const c = countries.find((n) => n.code === code)

  if (c) {
    return c
  }

  return {
    name: getName(code),
    code: code,
    id: id++,
  }
}

export function getCountryById(id) {
  return countries.find((n) => n.id === id)
}
